<template>
  <v-container class="container--large faq padding-left-right">
    <div class="pt-4 mb-12">
      <v-skeleton-loader type="text" loading class="breadcrumb-loader" />
    </div>
    <div class="pt-6">
      <v-skeleton-loader type="text" loading class="heading-loader" />
    </div>

    <v-row align="center" justify="start" class="mt-8 faq_list mb-8 pa-2">
      <v-col cols="12" md="3">
        <v-skeleton-loader type="text" loading class="search-input-loader" />
      </v-col>
    </v-row>

    <v-row class="mb-4">
      <v-col cols="12" md="8" sm="7">
        <v-row align="center" justify="center" class="faq_list mb-8 pa-2">
          <v-col cols="12">
            <v-skeleton-loader
              v-for="i in 10"
              :key="i"
              type="text"
              loading
              class="search-result-text-loader"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="4" sm="5">
        <v-row align="center" justify="center" class="faq_list mb-8 pa-2">
          <v-col cols="12">
            <v-skeleton-loader
              type="text"
              loading
              class="search-result-text-loader mb-4"
            />
            <v-skeleton-loader
              v-for="i in 2"
              :key="i"
              type="paragraph"
              loading
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.faq_list {
  background-color: #fff;
  box-shadow: 0px 0.375rem 1.125rem rgba(0, 0, 0, 0.06);
  border-radius: 0.25rem;
  margin: -0.0625rem;
}
.breadcrumb-loader {
  width: 200px;
}
.heading-loader {
  width: 200px;
  &::v-deep .v-skeleton-loader__text {
    height: 20px;
  }
}
.heading-button-loader-1 {
  margin-right: 12px;
  &::v-deep .v-skeleton-loader__button {
    width: 170px;
    height: 20px;
  }
}
.heading-button-loader-2 {
  &::v-deep .v-skeleton-loader__button {
    width: 100px;
    height: 20px;
  }
}
.search-input-loader {
  // padding-bottom: 6px;
  padding-top: 4px;
  &::v-deep .v-skeleton-loader__text {
    height: 48px;
  }
}
.letter-loader {
  padding-top: 4px;
  padding-left: 10px;
  padding-right: 10px;
  &::v-deep .v-skeleton-loader__text {
    height: 16px;
  }
}
.search-result-heading-loader {
  margin-top: 40px;
  padding-bottom: 8px;
  width: 100px;
  &::v-deep .v-skeleton-loader__text {
    height: 22px;
  }
}
.search-result-text-loader {
  margin-bottom: 30px;
}
</style>
